import { render, staticRenderFns } from "./soroteca-armazenar.vue?vue&type=template&id=06257bcb&"
import script from "./soroteca-armazenar.vue?vue&type=script&lang=js&"
export * from "./soroteca-armazenar.vue?vue&type=script&lang=js&"
import style0 from "./soroteca-armazenar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports